<p-fieldset legend="Parecer técnico-jurídico">
  <div class="row">
    <label class="required col-12 col-form-label">
      Consta do procedimento parecer técnico-jurídico atestando a viabilidade da contratação?
    </label>
    <p-selectButton [options]="opcoesSimNao" optionValue="id" class="col-12"
      [(ngModel)]="entidade.ParecerTecnicoJuridico" [ngModelOptions]="{standalone: true}">
      <ng-template let-opcao>
        <span class="p-1" style="font-size: 0.8rem;">{{opcao.nome}}</span>
      </ng-template>
    </p-selectButton>
  </div>
</p-fieldset>

<p-fieldset legend="Audiência pública">
  <div class="row">
    <label class="required col-3 col-form-label">
      Houve audiência pública relativa ao processo licitatório?
    </label>
    <p-selectButton [options]="opcoesSimNao" optionValue="id" class="col-3" [(ngModel)]="entidade.AudienciaPublicaNao"
      [ngModelOptions]="{standalone: true}">
      <ng-template let-opcao>
        <span class="p-1" style="font-size: 0.8rem;">{{opcao.nome}}</span>
      </ng-template>
    </p-selectButton>
  </div>
  <div class="row" *ngIf="entidade.AudienciaPublicaNao === 'S'">
    <label class="required col-3 col-form-label">
      Data da audiência pública
    </label>
    <p-calendar (onFocus)="onFocusDate()"[(ngModel)]="entidade.AudienciaPublicaDt" [ngModelOptions]="{standalone: true}"
      inputStyleClass="form-control col-auto" dataType="string" dateFormat="dd/mm/yy" [showOnFocus]="true"
      [showButtonBar]="true" [showIcon]="true">
    </p-calendar>
  </div>
</p-fieldset>